import ExportActiveNumbersTable from './ExportActiveNumbersTable';

export default ExportActiveNumbersTable;
